// extracted by mini-css-extract-plugin
module.exports = {"loadingContainer":"styles_loadingContainer__S2Ro5","centered":"styles_centered__30RmL"};